import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { StarIcon, TrashIcon } from '@heroicons/react/24/outline';

const OccurrenceNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define color scheme
  const colors = {
    border: 'border-[#3599ab50]',
    rounded: 'rounded-lg',
    gradient: 'from-[color-mix(in_srgb,var(--brand-primary)_13%,transparent)] to-[color-mix(in_srgb,var(--brand-primary)_20%,transparent)]',
    borderBottom: 'border-blue-200',
    text: 'text-[#3599ab]',
    handle: 'border-2 border-blue-400 !bg-blue-400 hover:!bg-blue-50'
  };
  const edgeLabels = [];
  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`bg-white p-2 ${colors.rounded} shadow-lg border-2 ${colors.border} relative`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Delete button - Added opacity and transition */}
      <div 
        className={`absolute -top-3 left-1/2 -translate-x-1/2 w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-600 hover:text-white z-10 transition-opacity ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <TrashIcon className='w-4 h-4 p-0.5 hover:text-white text-black'/>
      </div>

      {/* Header section */}
      <div className={`p-3 py-5 bg-gradient-to-r ${colors.gradient} border-b ${colors.borderBottom} ${colors.rounded}`}>
        <div className="flex items-center gap-2">
          <StarIcon className='w-8 h-8 p-1.5 bg-white text-[#3599ab] rounded-full'/>
          <span className={`font-semibold ${colors.text}`}>Occurrence of Event</span>
        </div>
      </div>

      {/* Output handles */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 h-[50px]">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <>
            <Handle
              key={`output-${index}`}        
              type="source"
              position={Position.Right}
              id={`output-${index}`}
              className="w-3 h-3 !bg-blue-400 hover:!bg-blue-400"
              style={{ 
                top: `${((index + 1) * 100) / (outputEdges + 1)}%`
              }}
            />
          </>
        ))}
      </div>
    </div>
  );
};

export default OccurrenceNode; 
